import { render } from "../views/modal-carousel.html?vue&type=template&id=d405283c&ts=true&external"
import script from "../scripts/modal-carousel.ts?vue&type=script&lang=ts&external"
export * from "../scripts/modal-carousel.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/modal-carousel.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/modal-carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d405283c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d405283c', __exports__)) {
    api.reload('d405283c', __exports__)
  }
  
  module.hot.accept("../views/modal-carousel.html?vue&type=template&id=d405283c&ts=true&external", () => {
    api.rerender('d405283c', render)
  })

}


export default __exports__